module.exports = __webpack_public_path__ + "img/logo.7de0616b.svg";